var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.499 6.998a1.5 1.5 0 1 1 .001-3 1.5 1.5 0 0 1-.001 3zm15.91 4.581-8.995-8.995a1.994 1.994 0 0 0-1.415-.585h-7a2 2 0 0 0-2 2v7c0 .553.225 1.053.588 1.415l8.998 8.999a1.997 1.997 0 0 0 2.829 0l7-7a1.999 1.999 0 0 0-.005-2.833z"
  })));
};
export default SvgTag;